<template>
  <div class="content">
    <div class="main">
      <el-form
        size="mini"
        ref="form"
        :model="course_form"
        label-position="left"
        class="form"
        @submit.native.prevent
      >
        <el-form-item label="所属科目">
          <div style="overflow: hidden;">
            <div style="float:left">
              <el-radio-group
                @change="tchGetTchCurriculum"
                v-model="course_form.subject_id"
              >
                <el-radio
                  v-for="item of subjectList"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.name }}</el-radio
                >
              </el-radio-group>
            </div>
            <div style="float:right;line-height: 20px;" v-if="url">
              <svg
                style="float:left"
                t="1679988918392"
                class="icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="6530"
                width="20"
                height="20"
              >
                <path
                  d="M0 512c0 282.773333 229.226667 512 512 512s512-229.226667 512-512S794.773333 0 512 0 0 229.226667 0 512z"
                  fill="#DBE5FF"
                  p-id="6531"
                ></path>
                <path
                  d="M370.752 200.213333v62.677334c0 19.605333 13.888 35.52 30.997333 35.52 17.130667 0 30.997333-15.914667 30.997334-35.52V200.192h143.893333v62.677333c0 19.605333 13.888 35.52 30.997333 35.52 17.130667 0 30.997333-15.914667 30.997334-35.52V200.192h38.933333a70.613333 70.613333 0 0 1 70.613333 70.634667v479.424a70.613333 70.613333 0 0 1-70.613333 70.613333H332.48a70.613333 70.613333 0 0 1-70.613333-70.613333V270.826667a70.613333 70.613333 0 0 1 70.613333-70.634667h38.272v0.021333z m31.232-19.328c8.810667 0 16.064 7.850667 17.429333 18.133334l0.234667 3.498666V260.266667c0 11.925333-7.893333 21.632-17.664 21.632-8.768 0-16.042667-7.850667-17.408-18.133334l-0.213333-3.52V202.538667c0-11.925333 7.893333-21.632 17.621333-21.632z m205.824 0c8.768 0 16.064 7.850667 17.408 18.133334l0.256 3.498666V260.266667c0 11.925333-7.893333 21.632-17.664 21.632-8.768 0-16.064-7.850667-17.429333-18.133334l-0.234667-3.541333V202.517333c0-11.925333 7.893333-21.632 17.664-21.632z"
                  fill="#4377FF"
                  p-id="6532"
                ></path>
                <path
                  d="M399.829333 401.002667l2.432-2.858667a25.28 25.28 0 0 1 32.896-2.432l2.858667 2.432 67.008 67.008 67.050667-67.008a25.28 25.28 0 0 1 35.712 35.733333l-67.008 67.029334 66.986666 66.986666c8.853333 8.853333 9.898667 22.826667 2.474667 32.917334l-2.474667 2.837333a25.28 25.28 0 0 1-32.874666 2.432l-2.837334-2.432-67.029333-67.008-67.008 67.008a25.28 25.28 0 0 1-35.733333-35.733333l66.986666-67.008-66.986666-67.029334a25.28 25.28 0 0 1-2.432-32.874666l2.432-2.858667-2.432 2.858667z"
                  fill="#FFFFFF"
                  p-id="6533"
                ></path>
              </svg>

              <span
                style="
                              margin-right: 10px;
                              margin-left:5px;
                              cursor: pointer;
                              color: #3E98F6;
                            "
                @click="HelopWord"
                >培训计划
              </span>
            </div>
          </div>
        </el-form-item>

        <el-form-item class="input_left">
          <el-input
            v-model="course_form.title"
            placeholder="请输入课程的名称"
            @keyup.enter.native="search"
            clearable
          ></el-input>

          <el-button type="primary" style="margin-left: 20px" @click="search"
            >搜索</el-button
          >
        </el-form-item>
        <!-- <div class="icon_right">
          <div class="new">
            <div class="new_txt">最新</div>
            <div class="el-icon-caret-top top1"></div>
            <div class="el-icon-caret-bottom bottom1"></div>
          </div>
          <div class="hot">
            <div class="hot_txt">最热</div>
            <div class="el-icon-caret-top top2"></div>
            <div class="el-icon-caret-bottom bottom2"></div>
          </div>
        </div> -->
      </el-form>
      <el-row :gutter="20">
        <el-col :span="6" v-for="item of curriculumList" :key="item.id">
          <div class="video_list">
            <div
              @click="handleClickCard(item)"
              class="courses_img"
              :style="{
                backgroundImage: 'url(' + item.img_url + ')',
              }"
            ></div>
            <div class="courses_title">
              <div style="overflow: hidden;width: 100%;">
                <div class="title_subject" style="width: 70%">
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="item.title"
                    placement="top"
                  >
                    <div class="title_name">{{ item.title }}</div>
                  </el-tooltip>
                </div>
                <div class="top_tag">{{ item.training_type }}</div>
              </div>
              <div
                class="title_bottom title_name"
                style="width: 100%;height: 21px; overflow: hidden;"
              >
                <div class="left_bottom">
                  共 {{ item.video_num }} 节 | {{ item.host }}
                </div>
                <div class="right_bottom">{{ item.tch_num }}人已参加</div>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div style="margin: 20px; text-align: right">
        <el-pagination
          @current-change="handleCurrent"
          :current-page="page_no"
          :page-size="page_size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { getTchTrainingList } from "@/api/teachingResearchTraining.js";
import { tchGetTchSubjectAuth } from "@/api/classroom/teacher_api";

export default {
  data() {
    return {
      page_size: 20,
      page_no: 1,
      total: 0,
      course_form: {
        subjectIds: [],
        subject_id: "",
        title: "",
      },
      curriculumList: [],
      subjectList: [],
      url: "",
    };
  },
  mounted() {
    this.tchGetTchSubjectAuth();

    // this.getinfo();
  },
  methods: {
    HelopWord() {
      window.open(this.url);
      console.log(this.url);
    },
    getinfo() {
      console.log(typeof this.course_form.subjectIds, 123456878);
      this.course_form.subjectIds = this.subjectList;
      console.log(this.course_form.subjectIds, 123456);
      let newArr = [];
      this.course_form.subjectIds.forEach((item) => {
        newArr.push(item.id);
        console.log(newArr, 456789);
      });

      this.course_form.subjectIds = newArr;
    },
    tchGetTchCurriculum(val) {
      console.log(val, 456);
      // if (val === 1) {
      //   this.url = '13241'
      // }
      // if (val === 2) {
      //   this.url = '13241456'
      // }
      // if (val === 3) {
      //   this.url = '132444441'
      // }
      // if (val === "") {
      //   this.course_form.subjectIds = this.subjectList;
      //   console.log(this.course_form.subjectIds, 123456);
      //   let newArr = [];
      //   this.course_form.subjectIds.forEach((item) => {
      //     newArr.push(item.id);
      //     console.log(newArr, 456789);
      //   });
      //   console.log(newArr, 456789);

      //   this.course_form.subjectIds = newArr;
      //   console.log(this.course_form.subjectIds, 222);
      // } else {
      //   this.course_form.subjectIds = [val];
      //   console.log(this.course_form.subjectIds, "ces");
      // }
      this.page_no = 1;

      this.getTchTrainingList();
    },

    //搜索
    search() {
      this.page_no = 1;

      this.getTchTrainingList();
    },
    //获取学校科目权限列表
    tchGetTchSubjectAuth() {
      console.log("查询老师科目权限");
      tchGetTchSubjectAuth().then((res) => {
        this.subjectList = res.subjectList;
        this.course_form.subject_id = res.subjectList[0].id;
        console.log(this.course_form.subject_id, 45678978);
        if (this.$route.query) {
          const { title } = this.$route.query;
          this.course_form.title = title;
        }

        console.log("获取老师权限列表");
        console.log(res);

        if (res.subjectList.length == 0) {
          this.$message.warning("无科目权限");
          return;
        }

        this.course_form.subject_id = res.subjectList[0].id;

        this.getinfo();
        this.getTchTrainingList();
      });
    },

    //获取列表

    getTchTrainingList() {
      getTchTrainingList({
        subjectIds: this.course_form.subject_id,
        title: this.course_form.title,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        this.curriculumList = res.tchTrainingList;
        this.total = res.total;
        if (this.course_form.subject_id === 1) {
          this.url =
            "https://huewq7h021.feishu.cn/wiki/wikcn21GxLmMUhCyxpsr6JXEV7b";
        } else if (this.course_form.subject_id === 2) {
          this.url =
            "https://huewq7h021.feishu.cn/wiki/wikcnpFsvEXpLXs76yLNBAXbktd";
        } else if (this.course_form.subject_id === 3) {
          this.url =
            "https://huewq7h021.feishu.cn/wiki/wikcnsifEF6yF32zKxggPf2hFwJ";
        } else if (this.course_form.subject_id === 4) {
          this.url =
            "https://huewq7h021.feishu.cn/wiki/wikcnVgnMJWJmPgt3ZOVPuq8UMg";
        } else {
          this.url = "";
        }

        res.tchTrainingList.map((index) => {
          if (index.training_type === 1) {
            return (index.training_type = "基础");
          }
          if (index.training_type === 2) {
            return (index.training_type = "产品");
          }
          if (index.training_type === 3) {
            return (index.training_type = "编程");
          }
          if (index.training_type === 4) {
            return (index.training_type = "平台");
          }
        });
      });
    },
    //
    handleCurrent(val) {
      this.page_no = val;
      this.getTchTrainingList();
    },

    handleClickCard(item) {
      console.log(item);

      if (!this.$store.state.user.schoolInfo.isTry) {
        this.$router.push({
          name: "trainingForTeachersDetails",
          query: {
            id: item.id,
            title: item.title,
          },
        });
      } else {
        this.$message.warning("体验账号,暂无权限查看!");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}

.title {
  width: 100%;
  height: 63px;
  background-color: #fff;
  line-height: 63px;
  color: rgba(0, 0, 0, 1);
  font-size: 16px;
}

.title_left {
  color: rgba(0, 0, 0, 0.45);
  font-size: 16px;
  margin-left: 10px;
}

.main {
  width: 100%;
  height: auto;
  min-height: calc(100vh - 65px);
  background-color: #fff;
  padding: 24px;
  box-sizing: border-box;
  border-radius: 5px;
}

.main .el-input {
  width: 337px;
  height: 30px;
}

.form {
  overflow: hidden;
}

.input_left {
  float: left;
}

.icon_right {
  float: right;
  cursor: pointer;
}

.new {
  position: relative;
  top: 0;
  right: 125px;
}

.top1 {
  position: absolute;
  top: 0px;
  left: 0;
}

.bottom1 {
  position: absolute;
  top: 8px;
  left: 0;
}

.new_txt {
  width: 50px;
  position: absolute;
  left: -25px;
  top: 3px;
}

.hot {
  position: relative;
  top: 0;
  right: 50px;
}

.top2 {
  position: absolute;
  top: 0px;
  left: 0;
}

.bottom2 {
  position: absolute;
  top: 8px;
  left: 0;
}

.hot_txt {
  width: 50px;
  position: absolute;
  left: -25px;
  top: 3px;
}

.video_list {
  border: 1px solid #e4e7ed;
  margin-bottom: 20px;
  border-radius: 5px;
  background: white;
  cursor: pointer;
}

.courses_img {
  height: 0;
  padding-bottom: 69%;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border-radius: 5px 5px 0px 0px;
  background-color: #ccc;
}

.courses_title {
  flex: 1;
  padding: 10px;
}

.top_tag {
  float: right;
  margin-left: 10px;
  color: rgb(241, 90, 36);
  font-size: 10px;
  border: 1px solid rgb(241, 90, 36);
  padding: 2px 4px;
  border-radius: 5px;
  // position: absolute;
  // width: 40px;
  // height: 26px;
  // color: rgba(255, 255, 255, 1);
  // background-color: rgba(24, 144, 255, 1);
  // border-radius: 4px;
  // font-size: 14px;
  // line-height: 26px;
  // text-align: center;
}

.title_subject {
  text-align: center;
  line-height: 26px;
  color: rgba(80, 80, 80, 1);
  font-size: 16px;
  font-weight: bold;
  float: left;
  // background: #f00;
  // width: 100%;
  // text-align: center;
  // line-height: 26px;
  // color: rgba(80, 80, 80, 1);
  // font-size: 16px;
  // font-weight: bold;
}

.title_bottom {
  color: rgba(80, 80, 80, 1);
  font-size: 14px;
  overflow: hidden;
  margin-top: 10px;
}

.left_bottom {
  float: left;
}

.right_bottom {
  float: right;
}

/deep/ .el-breadcrumb {
  line-height: 63px;
  padding-left: 20px;
}

.title_name {
  overflow: hidden; //超出的文本隐藏
  text-overflow: ellipsis; //溢出用省略号显示
  display: -webkit-box;
  -webkit-line-clamp: 1; // 超出多少行
  -webkit-box-orient: vertical;
  text-align: left;
}
</style>
